
/**
 * 绩效指标类型
 * @param {String} itemType
 * @returns
 */
export function performanceTypeFilter(itemType) {
  let res = ''
  switch (itemType) {
    case 'organ':
      res = '区体育行政部门';
      break;
    case 'youth':
      res = '青训中心';
      break;
    case 'club':
      res = '精英机构/基地';
      break;
    case 'trainCamp':
      res = '训练营';
      break;
    default:
      res = '--';
      break;
  }
  return res;
}

export function booleanStatus(isType) {
  let res = '';
  switch (isType) {
    case true:
      res = '开启';
      break;
    case false:
      res = '关闭';
      break;
    default:
      res = '--';
      break;
  }
  return res
}


export function auditStateFilters(val) {
  if( Object.prototype.toString.call(val) !== '[object Number]') return '--'
  let res = '';
  switch (val) {
    case 0:
      res = '待审核';
      break;
    case 1:
      res = '通过';
      break;
    case 2:
      res = '拒绝申请';
      break;
    case 3:
      res = '继续完善材料';
      break;
    default:
      res = '--';
      break;
  }
  return res;
}
//export function scoreTypeFiler(itemType) {
//  let res = ''
//  switch (itemType) {
//    case 'echelon':
//      res = '专项工作--机构梯队';
//      break;
//    case 'coach':
//      res = '专项工作--教练员队伍';
//      break;
//    case 'train':
//      res = '专项工作--机构训练计划';
//      break;
//    case 'school':
//      res = '体教融合';
//      break;
//    case 'football':
//      res = '机构场地设施--足球场';
//      break;
//    case 'site':
//      res = '机构场地设施--场地使用权限';
//      break;
//    case 'facilities':
//      res = '机构场地设施--辅助配套设施';
//      break;
//    case 'match':
//      res = '机构培养成效--高水平赛事';
//      break;
//    case 'camp':
//      res = '机构培养成效--集训营';
//      break;
//    default:
//      res = '--';
//      break;
//  }
//  return res;
//}

export function scoreTypeFiler(itemType) {
  let res = ''
  switch (itemType) {
    case 'echelon':
      res = '专项工作--机构梯队';
      break;
    case 'coach':
      res = '技术团队--教练规模';
      break;
    case 'train':
      res = '专项工作--机构训练计划';
      break;
    case 'school':
      res = '办训特色--教育保障';
      break;
    case 'football':
      res = '场地设施--场地数量';
      break;
    case 'site':
      res = '机构场地设施--场地使用权限';
      break;
    case 'facilities':
      res = '场地设施--辅助配套设施';
      break;
    case 'match':
      res = '培养过程--参赛场次';
      break;
    case 'camp':
      res = '机构培养成效--集训营';
      break;
    case 'footballproperty':
      res = '场地设施--产权租约';
      break;
    case 'coachlevel':
      res = '技术团队--教练等级';
      break;
    case 'major':
      res = '技术团队--青训总监';
      break;
    case 'compositeteam':
      res = '技术团队--复合团队';
      break;
    case 'team':
      res = '球员规模--梯队建设';
      break;
    case 'player':
      res = '球员规模--注册球员';
      break;
    case 'event':
      res = '培养过程--训练计划';
      break;
    case 'plan':
      res = '培养过程--教案质量';
      break;
    case 'playertalent':
      res = '人才输送';
      break;
    case 'schooltrain':
      res = '办训特色--普及培训';
      break;
    case 'rank':
      res = '参赛成绩';
      break;
    case 'qualityoftalents':
      res = '人才质量';
      break;
    default:
      res = '--';
      break;
  }
  return res;
}

// 精英集训队/训练营/参赛队
export function trainCampTypeFilter(itemType) {
  let res = ''
  switch (itemType) {
    case 'bootcamp':
      res = '训练营';
      break;
    case 'trainTeam':
      res = '集训队';
      break;
    case 'matchTeam':
      res = '参赛队';
      break;
    case 'trainCamp':
      res = '训练营';
      break;
    case 'other':
      res = '其他';
      break;
    default:
      res = '--';
      break;
  }
  return res;
}

export function coachTypeEnumTypeFilter(itemType) {
  let res = ''
  switch (itemType) {
    case 'YOUTHDIRECTOR':
      res = '青训总监';
      break;
    case 'PHYSICALCOACH':
      res = '体能教练员';
      break;
    case 'REHABILITATION':
      res = '运动康复师';
      break;
    case 'TEAMDOCTOR':
      res = '队医';
      break;
    case 'OTHER':
      res = '其他（技术分析师）';
      break;
    default:
      res = '--';
      break;
  }
  return res;
}
export function activityTypeEnumFilter(itemType) {
  let res = ''
  switch (itemType) {
    case 'NATIONALTEAM':
      res = '向国家队输送球员，并参加世界杯、亚洲杯等国际足联、亚足联举办的正式比赛';
      break;
    case 'NATIONALYOUTHTEAM':
      res = '向国奥、国青、国少队（15岁及以上）输送球员，并参加正式比赛';
      break;
    case 'GAMESTEAM':
      res = '向本市全运队（资格赛、决赛）、三大球运动会（决赛）输送球员，并参加正式比赛';
      break;
    case 'CLUBTEAM':
      res = '向本市职业足球俱乐部一线队输送球员，并参加正式比赛';
      break;
    case 'NATIONALTRAIN':
      res = '向中国足协各级选拔集训队输送球员';
      break;
    case 'GAMESTRAIN':
      res = '向本市全运队、三大球运动会选拔集训队（未进入资格赛、决赛名单）输送球员';
      break;
    case 'POINTTEAM':
      res = '向本市学青会、重点城市参赛队等输送球员并参加正式比赛';
      break;
    case 'CLUBTRAIN':
      res = '向本市职业足球俱乐部梯队输送球员';
      break;
    case 'DISTRICTTRAIN':
      res = '向本市/市足协各级青少年选拔集训队、训练营等输送球员';
      break;
    case 'DISTRICTTEAM':
      res = '向区级代表队输送球员并参加市级及以上正式比赛。(仅限B类机构)';
      break;
    case 'TOPTRAIN':
      res = '向双一流、985及211高校输送球员';
      break;
    default:
      res = '--';
      break;
  }
  return res;
}

